<template>
  <div class="side-nav">
    <div class="buttons">
      <div v-if="!hasBackButton">
        <a v-if="isInOrg && isOrgActive" :href="VUE_APP_AUTHORING_TOOL_REDIRECT">
          <menu-button label="SCENARIOS" />
        </a>
        <a v-if="showOdinButton" :href="odinHandoffUrl">
          <menu-button label="ODIN" />
        </a>
        <a v-if="!isStudent" href="/authoring/assignments">
          <menu-button label="ASSIGNMENTS" />
        </a>
        <a href="/auth/account/profile">
          <menu-button label="ACCOUNT" :badge="accountBadge" />
        </a>
        <a v-if="isInOrg && !isStudent" :href="isKeyOwner ? '/auth/org/profile' : isAdmin ? '/auth/org/invite' : '/auth/org/groups'">
          <menu-button label="ORG MANAGEMENT" />
        </a>
        <a v-if="isSuperAdmin" href="/auth/access/organizations">
          <menu-button label="VES ACCESS" />
        </a>
        <a v-if="isSuperAdmin" href="/cms">
          <menu-button label="CMS" />
        </a>
      </div>
      <div v-else>
        <menu-button :label="backLabel" icon="arrow_back" @click="onBack()" />
      </div>
    </div>
    <notification-list v-if="!hasBackButton" />
  </div>
</template>

<script>
import MenuButton from '../MenuButton.vue';
import NotificationList from './NotificationList';

export default {
  name: 'side-nav',
  components: {
    MenuButton,
    NotificationList,
  },
  props: {
    isInOrg: {
      type: Boolean,
      default: false,
    },
    isKeyOwner: {
      type: Boolean,
      default: false,
    },
    isOrgActive: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isSuperAdmin: {
      type: Boolean,
      default: false,
    },
    isStudent: {
      type: Boolean,
      default: false,
    },
    hasPaymentIssue: {
      type: Boolean,
      default: true,
    },
    isPendingInvitation: {
      type: Boolean,
      default: false,
    },
    hasBackButton: {
      type: Boolean,
      default: false,
    },
    backLabel: {
      type: String,
      default: 'Return to cases',
    },
    showOdinButton: {
      type: Boolean,
      default: false,
    },
    odinHandoffUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      VUE_APP_AUTHORING_TOOL_REDIRECT: process.env.VUE_APP_AUTHORING_TOOL_REDIRECT,
    };
  },
  computed: {
    accountBadge() {
      const showBadge = this.hasPaymentIssue || this.isPendingInvitation;
      return showBadge ? '!' : null;
    },
  },
  methods: {
    onBack() {
      this.$emit('onBack');
    },
  },
};
</script>

<style scoped>
.side-nav {  
  height: 100%;
  width: 15%;
  min-width: 200px;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  float: left;

  background-color: #303243;
  box-shadow: 4px 0 4px 0 rgba(0, 0, 0, 0.35);

  display: flex;
  flex-direction: column;
}

.buttons {
  display: flex;
  flex-direction: column;
}

.side-nav .md-button {
  width: 100%;
  margin-top: 4px !important;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25) !important;
}

.side-nav .menu-button {
  text-transform: uppercase;
}
</style>

<style>
.side-nav .md-button > .md-ripple {
  padding-left: 20px;
  padding-right: 20px;
}
</style>
